export const types = {
  SET_ORGANIZATION_NAMES: 'SET_ORGANIZATION_NAMES',
  UPDATE_OPERATOR_ORGANIZATION_TABLE_ROWS: 'UPDATE_OPERATOR_ORGANIZATION_TABLE_ROWS',
};
